(function () {

  const cursor = document.getElementById("image-cursor");
  const cursorImg = document.getElementById("cursor-img");

  if (!cursor || !cursorImg) return;

  // Hard-lock system cursor off on desktop
  document.documentElement.style.cursor = "none";
  document.body.style.cursor = "none";

  const normalSrc = "https://cdn.shopify.com/s/files/1/0685/7464/2422/files/Honey_Arrow_Bee--cursor--SweezyCursors.png?v=1771306794";
  const hoverSrc = "https://cdn.shopify.com/s/files/1/0685/7464/2422/files/Honey_Arrow_Bee--pointer--SweezyCursors.png?v=1771306781";

  // CSS selector for standard interactive elements
  const INTERACTIVE_SELECTOR = [
    "a", "button", "input", "textarea", "select",
    "label", "summary", "[role='button']", ".card", ".product-card"
  ].join(", ");

  // Known IDs / class prefixes for 3rd-party chat widgets that render
  // as fixed-position elements (their iframes swallow mouse events so
  // mousemove never fires over them from our document).
  const CHAT_WIDGET_SELECTORS = [
    "#zsiq_float",       // Zoho SalesIQ launcher button
    "#zsiq_floatmain",
    "[id^='zsiq']",
    "[class^='zsiq']",
    "[id^='zls']",
    "#respondio__widget",
    "[id^='respondio']",
    "[id^='sleekflow']",
    "#chat-widget",
    ".intercom-launcher",
    ".fc-open",          // Freshchat
  ];

  let isHovering = false;
  let mouseX = -999;
  let mouseY = -999;

  // ── Helpers ──────────────────────────────────────────────────────────────

  /**
   * Returns true if the given point (px, py) is inside the bounding rect
   * of the element, with an optional padding in pixels.
   */
  function pointInElement(el, px, py, padding) {
    padding = padding || 0;
    const r = el.getBoundingClientRect();
    return (
      px >= r.left - padding &&
      px <= r.right + padding &&
      py >= r.top - padding &&
      py <= r.bottom + padding
    );
  }

  /**
   * Check whether the current mouse position is inside any known chat
   * widget element. This is the fallback for iframes that eat events.
   */
  function isOverChatWidget() {
    for (const sel of CHAT_WIDGET_SELECTORS) {
      const els = document.querySelectorAll(sel);
      for (const el of els) {
        if (pointInElement(el, mouseX, mouseY, 8)) return true;
      }
    }
    return false;
  }

  // ── Core: handle mousemove ────────────────────────────────────────────────

  function moveCursor(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    // Position: subtract 2px so the hot-spot is at the tip
    cursor.style.transform = `translate(${mouseX - 2}px, ${mouseY - 2}px)`;

    // Restore any scale from the click effect
    if (cursor.style.transform.includes("scale")) {
      cursor.style.transform = `translate(${mouseX - 2}px, ${mouseY - 2}px)`;
    }

    // 1. Standard DOM interactive element?
    const interactive = e.target.closest(INTERACTIVE_SELECTOR);
    // 2. Over a chat widget area? (handles iframe / shadow DOM)
    const overChat = isOverChatWidget();

    const shouldHover = !!(interactive || overChat);

    if (shouldHover && !isHovering) {
      cursorImg.src = hoverSrc;
      isHovering = true;
    } else if (!shouldHover && isHovering) {
      cursorImg.src = normalSrc;
      isHovering = false;
    }
  }

  document.addEventListener("mousemove", moveCursor);

  // ── Polling fallback: keep checking while cursor is near bottom-right ─────
  // When the mouse is inside an iframe the browser stops firing mousemove on
  // our document.  We poll every 100 ms and update the bee/arrow accordingly.
  setInterval(function () {
    if (mouseX < 0) return; // cursor never moved yet

    const overChat = isOverChatWidget();

    if (overChat && !isHovering) {
      cursorImg.src = hoverSrc;
      isHovering = true;
    } else if (!overChat && isHovering) {
      // Only revert if no regular interactive element is hovered
      const docTarget = document.elementFromPoint(mouseX, mouseY);
      const interactive = docTarget && docTarget.closest(INTERACTIVE_SELECTOR);
      if (!interactive) {
        cursorImg.src = normalSrc;
        isHovering = false;
      }
    }
  }, 80);

  // ── Visibility ────────────────────────────────────────────────────────────

  document.addEventListener("mouseleave", function () {
    cursor.style.opacity = "0";
  });

  document.addEventListener("mouseenter", function () {
    cursor.style.opacity = "1";
  });

  // Restore opacity on any move
  document.addEventListener("mousemove", function () {
    if (cursor.style.opacity === "0") {
      cursor.style.opacity = "1";
    }
  });

  // ── Click effect ──────────────────────────────────────────────────────────

  document.addEventListener("mousedown", function (e) {
    const x = mouseX - 2;
    const y = mouseY - 2;
    cursor.style.transform = `translate(${x}px, ${y}px) scale(0.8)`;

    // Briefly hide on dropdowns/quantity buttons
    if (e.target.closest("select, .card-qty-btn, .quantity__button")) {
      cursor.style.opacity = "0";
      setTimeout(function () {
        cursor.style.opacity = "1";
      }, 100);
    }
  });

  document.addEventListener("mouseup", function () {
    const x = mouseX - 2;
    const y = mouseY - 2;
    cursor.style.transform = `translate(${x}px, ${y}px)`;
  });

})();
